import _get from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/get";
import _classCallCheck from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/inherits";
import { Component, findDOMfromVNode } from 'inferno';
import { InfernoEffectHost } from './effect_host';

var areObjectsEqual = function areObjectsEqual(firstObject, secondObject) {
  var bothAreObjects = firstObject instanceof Object && secondObject instanceof Object;

  if (!bothAreObjects) {
    return firstObject === secondObject;
  }

  var firstObjectKeys = Object.keys(firstObject);
  var secondObjectKeys = Object.keys(secondObject);

  if (firstObjectKeys.length !== secondObjectKeys.length) {
    return false;
  }

  var hasDifferentElement = firstObjectKeys.some(function (key) {
    return firstObject[key] !== secondObject[key];
  });
  return !hasDifferentElement;
};

export var BaseInfernoComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(BaseInfernoComponent, _Component);

  function BaseInfernoComponent() {
    var _this;

    _classCallCheck(this, BaseInfernoComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseInfernoComponent).apply(this, arguments));
    _this._pendingContext = _this.context;
    return _this;
  }

  _createClass(BaseInfernoComponent, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_, context) {
      this._pendingContext = context !== null && context !== void 0 ? context : {};
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !areObjectsEqual(this.props, nextProps) || !areObjectsEqual(this.state, nextState) || !areObjectsEqual(this.context, this._pendingContext);
    }
  }]);

  return BaseInfernoComponent;
}(Component);
export var InfernoComponent =
/*#__PURE__*/
function (_BaseInfernoComponent) {
  _inherits(InfernoComponent, _BaseInfernoComponent);

  function InfernoComponent() {
    var _this2;

    _classCallCheck(this, InfernoComponent);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(InfernoComponent).apply(this, arguments));
    _this2._effects = [];
    return _this2;
  }

  _createClass(InfernoComponent, [{
    key: "createEffects",
    value: function createEffects() {
      return [];
    }
  }, {
    key: "updateEffects",
    value: function updateEffects() {}
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      InfernoEffectHost.lock();
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate() {
      InfernoEffectHost.lock();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      InfernoEffectHost.callbacks.push(function () {
        _this3._effects = _this3.createEffects();
      });
      InfernoEffectHost.callEffects();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this4 = this;

      InfernoEffectHost.callbacks.push(function () {
        return _this4.updateEffects();
      });
      InfernoEffectHost.callEffects();
    }
  }, {
    key: "destroyEffects",
    value: function destroyEffects() {
      this._effects.forEach(function (e) {
        return e.dispose();
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyEffects();
    }
  }]);

  return InfernoComponent;
}(BaseInfernoComponent);
export var InfernoWrapperComponent =
/*#__PURE__*/
function (_InfernoComponent) {
  _inherits(InfernoWrapperComponent, _InfernoComponent);

  function InfernoWrapperComponent() {
    var _this5;

    _classCallCheck(this, InfernoWrapperComponent);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(InfernoWrapperComponent).apply(this, arguments));
    _this5.vDomElement = null;
    _this5.vDomPreviousClasses = [];
    _this5.vDomRemovedClasses = [];
    _this5.vDomAddedClasses = [];
    return _this5;
  }

  _createClass(InfernoWrapperComponent, [{
    key: "vDomUpdateClasses",
    value: function vDomUpdateClasses() {
      var _this6 = this;

      var _a;

      var currentClasses = ((_a = this.vDomElement) === null || _a === void 0 ? void 0 : _a.className.length) ? this.vDomElement.className.split(' ') : [];
      var addedClasses = currentClasses.filter(function (className) {
        return _this6.vDomPreviousClasses.indexOf(className) < 0;
      });
      var removedClasses = this.vDomPreviousClasses.filter(function (className) {
        return currentClasses.indexOf(className) < 0;
      });
      addedClasses.forEach(function (value) {
        var indexInRemoved = _this6.vDomRemovedClasses.indexOf(value);

        if (indexInRemoved > -1) {
          _this6.vDomRemovedClasses.splice(indexInRemoved, 1);
        } else {
          _this6.vDomAddedClasses.push(value);
        }
      });
      removedClasses.forEach(function (value) {
        var indexInAdded = _this6.vDomAddedClasses.indexOf(value);

        if (indexInAdded > -1) {
          _this6.vDomAddedClasses.splice(indexInAdded, 1);
        } else {
          _this6.vDomRemovedClasses.push(value);
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _a;

      _get(_getPrototypeOf(InfernoWrapperComponent.prototype), "componentDidMount", this).call(this);

      this.vDomElement = findDOMfromVNode(this.$LI, true);
      this.vDomPreviousClasses = ((_a = this.vDomElement) === null || _a === void 0 ? void 0 : _a.className.length) ? this.vDomElement.className.split(' ') : [];
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _a;

      _get(_getPrototypeOf(InfernoWrapperComponent.prototype), "componentDidUpdate", this).call(this);

      var element = this.vDomElement;

      if (element !== null) {
        this.vDomAddedClasses.forEach(function (className) {
          return element.classList.add(className);
        });
        this.vDomRemovedClasses.forEach(function (className) {
          return element.classList.remove(className);
        });
        this.vDomPreviousClasses = ((_a = this.vDomElement) === null || _a === void 0 ? void 0 : _a.className.length) ? this.vDomElement.className.split(' ') : [];
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var shouldUpdate = _get(_getPrototypeOf(InfernoWrapperComponent.prototype), "shouldComponentUpdate", this).call(this, nextProps, nextState);

      if (shouldUpdate) {
        this.vDomUpdateClasses();
      }

      return shouldUpdate;
    }
  }]);

  return InfernoWrapperComponent;
}(InfernoComponent);